/**
 * OMD-21: OpenSearch 검색 페이지네이션의 다음 페이지 offset(position) 계산.
 *
 * 다음 offset = "지금까지 소비한 고유 매치 emailId 중 서버 목록에 아직 남아있는(=이동/삭제 안 된) 수".
 *
 * 중요(레이스 방지): 이 값은 반드시 **응답(resolve) 시점** — searchMatchedIds 가 이번 페이지 결과로
 * 완전히 갱신된 직후 — 에 계산·확정해야 한다. 다음 요청을 보내는 시점에 재계산하면, fake 2단계
 * 로딩/재검색 churn 도중 아직 완전히 채워지지 않은 집합을 읽어 1건 undercount 되고(offset 0→19→39…),
 * 중복 수신→dedup→표시 누락 + 마지막 페이지 조기 종료(예: total 76인데 75에서 정지)를 유발한다.
 *
 * @param matchedIds 지금까지 소비한 고유 매치 emailId 집합(Set 등 iterable)
 * @param isRemoved  해당 id 가 서버 목록에서 빠졌는지(이동/삭제 등) 여부 판정
 * @returns 다음 페이지에 사용할 offset
 */
export function countConsumedMatches(
  matchedIds: Iterable<string>,
  isRemoved: (id: string) => boolean,
): number {
  let count = 0
  for (const id of matchedIds) {
    if (isRemoved(id) !== true) {
      count += 1
    }
  }
  return count
}
